import React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PersonIcon from "@mui/icons-material/Person";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ForkLeftIcon from "@mui/icons-material/ForkLeft";
import { useAppDispatch, useAppSelector } from "../../../framework/customStore";
import {
    setIsWorkShiftView,
    setSelectedVehicleId,
    setSelectedEmployeeId,
    setSelectedWorkShiftTimeSlotId,
    setSelectedWorkShift,
    setActiveTab,
    setIsVehicleDetailView,
    resetTripDateRangeToToday
} from "../../../store/monitorViewSlice";

interface SidebarHeaderProps {
    workShiftSidebarProps: any;
    header: string;
    activeVehicles: string;
    activeEmployees: string;
}

const SidebarHeader: React.FC<SidebarHeaderProps> = ({
    workShiftSidebarProps,
    header,
    activeVehicles,
    activeEmployees,
}) => {
    const dispatch = useAppDispatch();

    const tab = useAppSelector(
        (state) => state.monitorView.activeTab
    );
    const isWorkShiftView = useAppSelector(
        (state) => state.monitorView.isWorkShiftView
    );
    const isVehicleDetailView = useAppSelector(
        (state) => state.monitorView.isVehicleDetailView
    );

    const workShift = workShiftSidebarProps?.data?.[0]?.workShift;
    const effectiveDate = workShift?.effectiveDate;
    const employeeId = workShift?.employeeId;

    const closeWorkShiftView = () => {
        dispatch(setIsWorkShiftView(false));
        dispatch(setSelectedWorkShift(null));
        dispatch(setSelectedWorkShiftTimeSlotId(null));
        dispatch(setSelectedEmployeeId(null));
    };

    const closeVehicleDetailView = () => {
        dispatch(setIsVehicleDetailView(false));
        dispatch(setSelectedVehicleId(null));
        dispatch(resetTripDateRangeToToday());
    };

    return (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
            {isWorkShiftView ? (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
                    <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1, justifyContent: "flex-start" }}>
                        <ArrowBackIcon
                            onClick={closeWorkShiftView}
                        />
                    </Box>
                    <Tabs value={0} sx={{ flexGrow: 0 }}>
                        <Tab label={header} icon={<PersonIcon sx={{ color: "#FFFFFF" }} />} />
                    </Tabs>
                    <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1, justifyContent: "flex-end" }}>
                        {effectiveDate ? (
                            <a
                                href={`/worktimepage/details/${employeeId}/${effectiveDate}/hourbooking`}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <OpenInNewIcon fontSize="small" color="primary" />
                            </a>
                        ) : null}
                    </Box>
                </Box>
            ) : isVehicleDetailView ? (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
                    <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1, justifyContent: "flex-start" }}>
                        <ArrowBackIcon
                            onClick={closeVehicleDetailView}
                        />
                    </Box>
                    <Tabs value={0} sx={{ flexGrow: 0 }}>
                        <Tab label={header} icon={<ForkLeftIcon sx={{ color: "#FFFFFF" }} />} />
                    </Tabs>
                    <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1, justifyContent: "flex-end" }}>
                        {/* Placeholder for future content, like additional icons or actions */}
                    </Box>
                </Box>
            ) : (
                <Box sx={{ margin: "0 auto", display: "flex", alignItems: "center" }}>
                    <Tabs onChange={(e, val) => dispatch(setActiveTab(val))} value={tab}>
                        <Tab label={`Kalusto (${activeVehicles})`} icon={<LocalShippingIcon fontSize="medium" sx={{ color: "#FFFFFF" }} />} />
                        <Tab label={`Työntekijät (${activeEmployees})`} icon={<PersonIcon fontSize="medium" sx={{ color: "#FFFFFF" }} />} />
                    </Tabs>
                </Box>
            )}
        </Box>
    );
};

export default SidebarHeader;